<template>
  <SkinOutlined title="主题配置" :style="{fontSize: '20px', display: 'block', cursor: 'pointer'}" @click="themeOpen=true" />
  <a-modal v-model:open="themeOpen" title="主题配置" @ok="handleSave">
    <div class="theme">
      <ul>
        <li
          v-for="(item,index) in themeList"
          :key="index"
          @click="changeTheme(item.value,index)"
        >
          <p :style="`background:${item.value}`">
            <CheckOutlined v-if="item.active" class="active" />
          </p>
          <p>{{ item.label }}</p>
        </li>
      </ul>
    </div>

  </a-modal>
</template>
<script setup>
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const themeOpen = ref(false) // 主题配置弹窗

const state = reactive({
  themeColor: [
    {
      label: '中车红',
      value: '#c70019',
      active: false
    }, {
      label: '薄暮',
      value: '#F5222D',
      active: false
    }, {
      label: '火山',
      value: '#FA541C',
      active: false
    }, {
      label: '日暮',
      value: '#FAAD14',
      active: false
    }, {
      label: '明青',
      value: '#13C2C2',
      active: false
    }, {
      label: '极光绿',
      value: '#52C41A',
      active: false
    }, {
      label: '拂晓蓝',
      value: '#1890FF',
      active: false
    }, {
      label: '极客蓝',
      value: '#2F54EB',
      active: false
    }, {
      label: '酱紫',
      value: '#722ED1',
      active: false
    }
  ]
})
const changeTheme = (color, i) => {
  localStorage.setItem('themeColor', color)
  state.themeColor = state.themeColor.map((item, index) => {
    if (index === i) {
      item.active = true
    } else {
      item.active = false
    }
    return item
  })
  store.commit('updateThemeColor', color)
}
const themeList = computed(() => {
  const theme = localStorage.getItem('themeColor')
  const arr = state.themeColor.map(item => {
    if (theme && item.value === theme) {
      item.active = true
    }
    return item
  })
  return arr
})

const handleSave = () => {
  themeOpen.value = false
}
</script>
<style lang="less" scoped>
.theme{
  ul{
    list-style: none;
    margin: 0;
    padding: 0;
    li{
      width: 50px;
      float: left;
      margin-right: 10px;
      text-align: center;
      cursor: pointer;
      p{
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .active{
          font-size: 30px;
          color: #ffffff;
        }
        &:first-child{
          width: 50px;
          height: 50px;
        }
        &:last-child{
          padding-top: 5px;
          font-size: 13px;
        }
      }
    }
    &::after{
      content: '';
      display: block;
      height: 0;
      clear: both;
    }
  }
}
</style>
